import { Portfolio } from '../business/api/portfolio/portfolio';

/**
 * Modify the /portfolio response to reference the Member object directly from the contract
 * and reference the Member in the carrousel.
 * Only memberId are set in both contracts and carrousel of /portfolio response
 */
export const mapResponseToPortfolio = (response: any): Portfolio => {
    if ('contracts' in response) {
        response.contracts = _mapContracts(response);
    }
    if ('carrousel' in response) {
        response.carrousel = _mapCarrousel(response);
    }
    return response as Portfolio;
};

function _mapContracts(response: any) {
    if (Array.isArray(response.contracts)) {
        response.contracts
            .filter((contract) => Array.isArray(contract.associatedFamilyMembers))
            .forEach((contract) => {
                contract.associatedFamilyMembers = _mapFamilyMemberToContractAssociatedMember(contract, response);
            });
    }
    return response.contracts;
}

const _mapFamilyMemberToContractAssociatedMember = (contract, response) => {
    return contract.associatedFamilyMembers.map(
        (associatedMember) =>
            // families is an array but it can only contains one family when called by OIDVAL
            response.families[0].members.find((member) => member.id === associatedMember.id) || associatedMember,
    );
};

function _mapCarrousel(response: any) {
    if (Array.isArray(response.carrousel)) {
        response.carrousel
            .filter((item) => item.memberId)
            .forEach((item) => {
                item.member = response.families[0].members.find((member) => member.id === item.memberId);
            });
    }
    return response.carrousel;
}
